import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterLumpini extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>MARINE MARTIAL ARTS DOJO LUMPINI's MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-teerayutp'>1. AAT 2471  CAPT.TEERAYUT PAKDEEPAK(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-worapotb'>2. AAT 2712  MR.WORAPOT  BENJANART(A)</Link></div>
      <br />
      <div><Link to='/conduct-amornpont'>3. AAT  2188  MR.AMORNPON TEEPANART(A)</Link></div>
      <br />
      <div><Link to='/conduct-pongnarts'>4. AAT  6856  MR.PONGNART SAPSOMPONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-wannarats'>5. AAT  6201  MS.WANNARAT SOMBATPINYO(A)</Link></div>
      <br />
      <div><Link to='/conduct-ekasitw'>6. AAT  1187  MR.EKASIT WIPULANUSAT(A)</Link></div>
      <br />
      <div><Link to='/conduct-jarunnops'>7. AAT  7561  MR.JARUNNOP SIRIVORAPAIBOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-suteed'>8. AAT  8023  COL.SUTEE DUANGTOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-yuthanas'>9. AAT  8110  MR.YUTHANA SANGMUANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-praphatpongy'>10. AAT  8038  MR.PRAPHATPHONG YOODEE(A)</Link></div>
      <br />
      <div><Link to='/conduct-kittichoten'>11. AAT  0878  MR.KITTICHOTE NAIYACHIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-vunqt'>12. AAT  8021  MS.VU NGUYEN QUYNH TRAM(A)</Link></div>
      <br />
      <div><Link to='/conduct-theerathasp'>13. AAT  7864  MR.THEERATHAS PAKDEEPAK(A)</Link></div>
      <br />
      <div><Link to='/conduct-naras'>14. AAT  8040  MASTER NARA SINGHSATHITSUK(A)</Link></div>
      <br />
      <div><Link to='/conduct-marks'>15. AAT  8041  MR.MARK SRIAPORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-marvins'>16. AAT  8042  MR.MARVIN SRIAPORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-mitts'>17. AAT  8043  MR.MITT SRIAPORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-pawatchakornh'>18. AAT  8052  MR.PAWATCHAKORN HASUNHA(A)</Link></div>
      <br />
      <div><Link to='/conduct-niksak'>19. AAT  8058  MR.NIKSA KIATTHANAPIBOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-paricharts'>20. AAT  8061  MS.PARICHART SRIAPORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-nattawuta'>21. AAT  6233  MR.NATTAWUT ASSARASRI(A)</Link></div>
      <br />
      <div><Link to='/conduct-praewpuns'>22. AAT  8010  PO.PRAEWPUN SUWANNAKOT(A)</Link></div>
      <br />
      <div><Link to='/conduct-riradav'>23. AAT  8011  PO.RIRADA VANITWORACHOT(A)</Link></div>
      <br />
      <div><Link to='/conduct-suphodh'>24. AAT  8012  CPO.SUPHOD HARASAN(A)</Link></div>
      <br />
      <div><Link to='/conduct-marcop'>25. AAT  8018  MR.MARCO PENNA(A)</Link></div>
      <br />
      <div><Link to='/conduct-shinehl'>26. AAT  8019  MR.SHINE HTET LINN(A)</Link></div>
      <br />
      <div><Link to='/conduct-suphatchayab'>27. AAT  8020  MS.SUPHATCHAYA BOONYASUKANON(A)</Link></div>
      <br />
      <div><Link to='/conduct-nichaj'>28. AAT  8039  MS.NICHA JAMJUN(A)</Link></div>
      <br />
      <div><Link to='/conduct-vaayuk'>29. AAT  8057  MASTER VAAYU KHATTRI(A)</Link></div>
      <br />
      <div><Link to='/conduct-piyabutrl'>30. AAT  8060  MR.PIYABUTR LORGRAILERS(A)</Link></div>
      <br />
      <div><Link to='/conduct-anukulc'>31. AAT  8069  MR.ANUKUL CHAMROON(A)</Link></div>
      <br />
      <div><Link to='/conduct-natchanonk'>32. AAT  8070  MR.NATCHANON KRAIRAVEE(A)</Link></div>
      <br />
      <div><Link to='/conduct-punnawatk'>33. AAT  8071  MR.PUNNAWAT KRAIRAVEE(A)</Link></div>
      <br />
      <div><Link to='/conduct-techathatw'>34. AAT  8072  MR.TECHATHAT WATTANAPHORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-yothsayaw'>35. AAT  8073  MS.YOTHSAYA WATTANAPORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-puttd'>36. AAT  8074  MR.PUTT DUANGTOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-sirapopes'>37. AAT  8075  MR.SIRAPOPE SOONTORNNUCH(A)</Link></div>
      <br />
        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterLumpini;
